export default __webpack_public_path__ + "static/media/art-red-3.fbc0199d.png";